import type { InfoHintDetail } from '@cou/admin-ui';
import { formatDateTime } from '../contests/format-date';
import type { AdminPlayer } from './players-client';

/** Only the fields the hint reads, so both the list row and the detail response satisfy it. */
export type PlayerHintSource = Pick<
  AdminPlayer,
  'id' | 'account' | 'segment' | 'segmentLabel' | 'state' | 'lastSeenAt' | 'entryCount'
>;

/**
 * The rows behind a player's ⓘ hint.
 *
 * Segment resolves label → raw → `default`: an unknown or blank segment *is* the default column of
 * the payout matrix (GL-12), so showing "default" tells the operator which column graded the
 * Entry. A blank would leave them guessing.
 */
export function playerDetails(player: PlayerHintSource): InfoHintDetail[] {
  return [
    { label: 'Player ID', value: player.id, copyable: true },
    { label: 'Account', value: player.account, copyable: true },
    { label: 'Segment', value: player.segmentLabel ?? player.segment ?? 'default' },
    { label: 'State', value: player.state ?? '—' },
    { label: 'Entries', value: player.entryCount },
    { label: 'Last seen', value: formatDateTime(player.lastSeenAt) },
  ];
}
